export const SandboxCursor = () => {
    return (
        <svg
            width="12"
            height="17"
            viewBox="0 0 12 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={true}
        >
            <path
                d="M11.9799 0.670036C11.7947 0.355771 11.4058 0.534611 11.2022 0.745499C8.01182 3.23378 4.79175 5.94537 1.78451 8.58458L1.82851 8.56802C-0.782751 11.1111 -0.764336 10.6511 2.97349 11.261C3.47896 11.4553 3.80332 11.2641 3.40631 11.8771C1.73539 15.1449 0.186236 14.5939 3.95271 15.8964C4.47762 15.9988 5.55302 16.7514 5.65637 16.4133C6.10556 15.8416 7.33752 13.3761 7.89722 13.5229C8.58176 13.8671 8.49376 14.2672 9.694 15.1325C10.3693 15.8458 10.3836 15.0301 10.442 14.4719C10.5689 13.5105 10.7305 13.2634 10.8912 12.301C10.8922 12.3237 10.9004 12.4653 10.9014 12.484C11.1112 12.1852 11.3762 8.11318 11.4294 8.97638C11.7445 6.45812 12.0873 3.32165 11.9799 0.670036Z"
                fill="#101214"
            />
        </svg>
    );
};
